var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransaksi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 4.25H6.375C5.81141 4.25 5.27091 4.47388 4.8724 4.8724C4.47388 5.27091 4.25 5.81141 4.25 6.375V27.625C4.25 28.1886 4.47388 28.7291 4.8724 29.1276C5.27091 29.5261 5.81141 29.75 6.375 29.75H27.625C28.1886 29.75 28.7291 29.5261 29.1276 29.1276C29.5261 28.7291 29.75 28.1886 29.75 27.625V6.375C29.75 5.81141 29.5261 5.27091 29.1276 4.8724C28.7291 4.47388 28.1886 4.25 27.625 4.25Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91699 16.2917H15.5837M14.8753 21.9583L18.417 24.7917L24.0837 17.7083L14.8753 21.9583ZM9.91699 10.625H24.0837H9.91699Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaksi);
export default __webpack_public_path__ + "static/media/transaksi.39e638dd3091ef7c28ba13b2f8cd63f8.svg";
export { ForwardRef as ReactComponent };